const h1Styles = {
  fontSize: "2rem",
  fontWeight: "bold",
  margin: "0.5rem 1rem",
};
const h2Styles = {
  fontSize: "1.5rem",
  fontWeight: "bold",
  margin: "1rem 1rem",
};

const olStyles = {
  listStyleType: "decimal",
  margin: "1rem 1rem",
  paddingLeft: "1rem",
};

const liStyles = {
  margin: "0.5rem 0.5rem",
  lineHeight: "1.5",
};
const pStyles = {
  margin: "1rem 1rem",
};
// https://docs.google.com/document/d/171jgVv4_Xixbfv5v9iWREzHeiwS8N-GnBAohBz_B2mg/edit を参考に作成。
export const TermsOfUseContents = () => (
  <>
    <h1 style={h1Styles}>medimo 利用規約</h1>
    <p style={pStyles}>
      本規約は、株式会社medimo（以下「当社」といいます。）が提供する「medimo」、及びその関連サービス（以下「本サービス」といいます。）をご利用いただく際の利用条件を定めています。
      本サービスの利用者は本規約の定める条件に従って本サービスを利用するものとします。
    </p>

    <h2 style={h2Styles}>第1条（規約の同意）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        本サービスの利用者は、あらかじめ本規約に同意した上で本サービスの利用を開始するものとします。本規約にご同意いただけない場合、利用者は本サービスを利用することはできませんので、その場合は本サービスの利用を中止してください。
      </li>
      <li style={liStyles}>
        利用者が本サービスを利用する場合、利用時点で最新の本規約に同意したものとみなします。
      </li>
      <li style={liStyles}>
        当社は、利用者の一般の利益に適合する場合等相当の事由があると認められる場合には、民法548条の4の規定に基づき、本規約の内容を変更できるものとします。この場合、当社は変更後の利用規約の内容を、当社が運営するウェブサイト内または本サービス内の適宜の場所への掲示をする等の方法により利用者に周知するものとし、相当な期間を経過した日から変更後の本規約が適用されるものとします。
      </li>
    </ol>

    <h2 style={h2Styles}>第2条（利用条件・登録等）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        利用者は、任意のパーソナルコンピュータ又はスマートフォン端末等（以下｢利用端末｣といいます。）を用いて、本サービスを利用することができます。ただし、利用端末、通信環境その他の本サービスの利用に必要な機器・外部環境については利用者自身の責任と費用で準備するものとします。
      </li>
      <li style={liStyles}>
        利用者は、SMS認証その他当社が定める方法により利用者登録を行い、利用を開始することができます。ただし、以下のいずれかの事由に当てはまる場合、当社は利用者の登録を拒否することがあります。
        <ol style={olStyles}>
          <li style={liStyles}>
            本規約に違反するおそれがあると当社が判断した場合
          </li>
          <li style={liStyles}>
            当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合
          </li>
          <li style={liStyles}>
            過去に本サービスの利用資格を停止又は取り消された者である場合
          </li>
          <li style={liStyles}>
            未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合
          </li>
          <li style={liStyles}>
            反社会的勢力等である、又は反社会的勢力等と何らかの関係があると当社が判断した場合
          </li>
          <li style={liStyles}>
            その他、当社が利用者登録を適当でないと合理的に判断した場合
          </li>
        </ol>
      </li>
      <li style={liStyles}>
        本サービスに関する著作権、知的財産権その他一切の権利は当社に帰属します。
      </li>
    </ol>

    <h2 style={h2Styles}>第3条（利用方法）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        本サービスの利用者は医師、看護師、理学療法士その他の医療従事者（以下「医療従事者等」といいます。）に限定しています。
      </li>
      <li style={liStyles}>
        ユーザーは、いかなる場合にも、ユーザーIDおよびパスワードを第三者に譲渡または貸与し、もしくは第三者と共用することはできません。当社は、ユーザーIDとパスワードの組み合わせが登録情報と一致してログインされた場合には、そのユーザーIDを登録しているユーザー自身による利用とみなします。
      </li>
      <li style={liStyles}>
        利用者は患者本人、同席する患者のパートナーや家族等の第三者（以下「パートナー等」といいます。）が本サービスの利用を認識できるよう本サービスを運用します。
      </li>
      <li style={liStyles}>
        利用者は、本サービスによる録音に対し、患者本人とパートナー等から反対があった場合に、当該診察において本サービスの利用を中止するものとします。
      </li>
      <li style={liStyles}>
        利用者は、記録データを同僚の医療従事者等、患者本人とパートナー等に共有することができます。ただし、記録データの共有は利用者自身の責任で行うものとします。
      </li>
      <li style={liStyles}>
        本サービスは、記録データにおいて確認された医療情報（疾患名、症状その他の事項）を抜粋し、利用者にとって電子診療録に記載しやすいフォーマットに要約する（以下「要約データ」）ことができます。
      </li>
    </ol>

    <h2 style={h2Styles}>第4条（機器等の貸与）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        当社は、利用者との別途の合意がある場合、利用者に対し、本サービスの利用に必要な機器等を、当社が別途定める期間、有償にて貸与します。
      </li>
      <li style={liStyles}>
        利用者は、機器等を当社指定の用法に従い、善良なる管理者の注意をもって、使用、管理するものとします。
      </li>
      <li style={liStyles}>
        利用者は、本サービスを利用して、医療従事者等に該当する場合は本人、該当しない場合は医療従事者等の同意のもと、医療従事者等による口頭での説明を録音し、音声認識システムによる文字起こし機能、そして書き起こされた説明をAIで要約する機能を利用することができます。
      </li>
      <li style={liStyles}>
        利用者は、記録データを同僚の医療従事者等、患者本人、患者のパートナーや家族等の第三者（以下「パートナー等」といいます。）に共有することができます。ただし、記録データの共有は利用者自身の責任で行うものとします。
      </li>
      <li style={liStyles}>
        利用者は、当社が貸与した機器等を分解または改造してはなりません。
      </li>
      <li style={liStyles}>
        利用者は、機器等を、第三者に転貸、譲渡または質入れその他の担保に供する等の処分をしてはなりません。
      </li>
    </ol>

    <h2 style={h2Styles}>第5条（利用料金）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        利用者は、当社に対して、利用申込に定められたサービス利用の対価（以下「利用料金」といいます）を支払うものとします。
      </li>
      <li style={liStyles}>
        利用契約を月の途中から開始する場合であっても、利用料金の日割り計算はいたしません。
      </li>
    </ol>

    <h2 style={h2Styles}>第6条（利用期間）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        利用契約の契約期間は、申込書又は契約書に記載された利用開始日から契約期間が満了するまでとします。
      </li>
      <li style={liStyles}>
        利用者から、当社所定の日までに当社所定の方法で更新の拒絶または契約条件の変更等の申し出がない場合には、利用契約は、同じ条件で更に自動的に更新されるものとし、以降も同様とします。
      </li>
      <li style={liStyles}>
        利用者は、利用契約の成立後、契約期間中に中途解約をすることは原則できません。
      </li>
    </ol>

    <h2 style={h2Styles}>第7条（支払い）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        利用者は、当社が別途定める本サービスの利用料金、機器等の貸与料その他の料金を、当社が別途定める方法にて支払うものとします。支払いに関する手数料は、利用者にてご負担いただきます。
      </li>
      <li style={liStyles}>
        利用者が、前項の料金に支払いを遅延した場合、利用者は年14.6%の割合による遅延損害金を当社に支払うものとします。
      </li>
      <li style={liStyles}>
        利用者は、利用料金の支払いを１回でも怠った場合、または本規約で定める禁止事項に違反した場合、利用契約上の全ての期限の利益を失うものとします。
      </li>
      <li style={liStyles}>
        本規約に別途定める場合を除き、当社が利用者から受領した利用料金の返金は一切しません。
      </li>
    </ol>

    <h2 style={h2Styles}>第8条（禁止事項）</h2>
    <p style={pStyles}>
      利用者は、本サービスの利用に関して、以下の行為を行ってはならないものとします。
    </p>
    <ol style={olStyles}>
      <li style={liStyles}>法令又は公序良俗に違反する行為</li>
      <li style={liStyles}>本規約に違反する行為</li>
      <li style={liStyles}>
        医療従事者等の同意を得ずに本サービスを利用する行為
      </li>
      <li style={liStyles}>
        本サービスを、利用者本人の便宜及び利用者のパートナー等との共有目的以外の、本規約が許諾しない方法・目的で利用する行為（たとえば紛争の解決のために記録データを訴訟等で利用することを含みますが、これに限られません）
      </li>
      <li style={liStyles}>第三者又は当社に対して損害を与える行為</li>
      <li style={liStyles}>
        第三者又は当社の知的財産権、プライバシー権その他法律上の権利を侵害する行為
      </li>
      <li style={liStyles}>本サービスを商用又はその準備の目的で利用する行為</li>
      <li style={liStyles}>
        本サービスを複製、変更、改変、翻案、分解、リバースエンジニアリング、逆コンパイル又は逆アセンブルする行為
      </li>
      <li style={liStyles}>
        本サービス及び本サービスを通じて提供する機能・効用の提供を妨げ又は妨げるおそれのある行為
      </li>
      <li style={liStyles}>
        その他、当社が社会通念上合理的と認められる根拠に基づき不適当と認める行為
      </li>
    </ol>

    <h2 style={h2Styles}>第9条（利用資格の停止等）</h2>
    <p style={pStyles}>
      ユーザーは，本サービスの利用にあたり，以下の行為をしてはなりません。
    </p>

    <ol style={olStyles}>
      <li style={liStyles}>
        当社は、利用者が次の各号の一に該当すると当社が判断した場合には、当社の裁量により、利用者への事前の通知又は承諾を要することなく、利用者による本サービスの利用の一時停止若しくは制限、又はアカウントの一時停止若しくは削除（以下「利用停止等」といいます。）の措置を講じることができるものとします。
      </li>
      <li style={liStyles}>
        第2条第2項各号又は前条各号に該当する場合又は該当するおそれがあった場合
      </li>
      <li style={liStyles}>
        死亡し又は後見開始、保佐開始若しくは補助開始の審判を受けた場合
      </li>
      <li style={liStyles}>
        支払停止若しくは支払不能となり、又は破産手続開始若しくはこれらに類する手続開始の申立てがあった場合
      </li>
      <li style={liStyles}>
        当社からの問い合わせに対して30日間以上応答がない場合
      </li>
      <li style={liStyles}>
        本サービスの運営を継続する上でやむを得ない事由がある場合
      </li>
      <li style={liStyles}>
        当社は、前項の定めに従い利用者の利用停止等の措置を講じた後も、当該利用者について当社が取得した情報を保有し又は利用することができるものとします。
      </li>
      <li style={liStyles}>
        当社は、本条に基づき当社が利用停止等の措置を執ったことにより利用者に生じた不利益や損害について、当社に故意又は重大な過失がない限り一切の責任を負いません。
      </li>
    </ol>

    <h2 style={h2Styles}>第10条（利用者の退会）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        利用者は、理由の如何を問わず、いつでも本サービスの利用を終了することができます。この場合、利用者は当社が別途定める方法に従い、退会し利用者資格を喪失するものとします。なお、本サービスの提供終了時には、すべての利用者は、自動的に退会するものとし､利用者資格を喪失するものとします。
      </li>
      <li style={liStyles}>
        利用者が退会した後、又は当社が本サービスの提供を終了した後は、当社は、本サービスの提供に必要な設備（以下「本設備」といいます。）に保管されている当該利用者に関する情報（記録データを含み、以下「利用者情報」といいます。）を保有し又は利用することができるものとし、利用者はこれに同意します。なお、当社が利用者情報を削除した後、当社は当該利用者情報の返却ないし提供の要求には一切応じないものとします。
      </li>
    </ol>

    <h2 style={h2Styles}>第11条（利用者情報の取扱い）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        当社は、利用者の個人情報について、別途定める
        <a
          href="/pdfs/privacy_policy.pdf"
          style={{
            overflowWrap: "break-word",
            color: "blue",
            textDecoration: "underline",
          }}
        >
          当社プライバシーポリシー
        </a>
        に基づき適切に取り扱うものとします。なお、本サービスには、法令により定められている場合を除き、利用者に対して、利用者が入力した情報の保存やバックアップデータの提供は含まれていません。必要な情報は利用者の責任で保存してください。
      </li>
    </ol>

    <h2 style={h2Styles}>第12条（保証・免責）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        当社は、本サービスの提供に関し、いかなる保証もしないものとします（記録データを含む利用者情報及び本サービスの正確性、完全性、有用性、最新性、適時性、特定目的適合性等を有することの保証を含み、これらに限りません）。
      </li>
      <li style={liStyles}>
        本サービスは当社の提携先等の第三者が提供するサービス又はコンテンツ（以下「第三者提供サービス等」といいます。）を含む場合があります。第三者提供サービス等に対する責任は、これを提供する事業者が負うものとし、当社はその責任を負いません。
      </li>
      <li style={liStyles}>
        当社は、以下の事由により、利用者に事前に通知することなく、やむを得ず一時的に本サービスの提供を中断することがあり、利用者はこれに予め同意するものとします。
      </li>
      <ol style={olStyles}>
        <li style={liStyles}>本設備の保守・点検・修理等を行う場合</li>
        <li style={liStyles}>
          本設備が故障・障害等により本サービスの提供が困難になった場合
        </li>
        <li style={liStyles}>
          天変地異等不可抗力により本サービスの提供が困難になった場合
        </li>
        <li style={liStyles}>
          その他、運用上又は技術上、本サービスの提供を一時的に中断すべきであると当社が合理的に判断した場合
        </li>
      </ol>
      <li style={liStyles}>
        当社は、障害発生時における復旧に供することを目的に、必要な範囲で利用者情報のバックアップ措置を実施しますが、利用者は、当社に対し当該バックアップ措置に関する如何なる請求（利用者の過失によるデータ喪失に対する復元要求を含みますが、これに限られません。）もなすことはできないものとします。
      </li>
      <li style={liStyles}>
        当社は、本サービスに関して利用者又は第三者に直接的又は間接的に生じた一切の損害（ハードウェア、ソフトウェア等の破損、不具合を含みます。また、通常障害、特別損害を問いません。）及び第三者からの請求等について、その損害が当社の故意又は過失による場合を除いて、一切責任を負わないものとします。また、当社の過失（重過失による場合を除きます。）によって本サービスに関して利用者に損害が生じた場合、当社は、債務不履行、不法行為その他の事由を問わず、ユーザに現実に生じた直接かつ通常の範囲の損害についてのみ責任を負い、その賠償額は、金1万円を上限とします。
      </li>
      <li style={liStyles}>
        当社は、AIのアウトプットを調整するための指示文章（以下プロンプト）のテンプレートや必要に応じたプロンプトのカスタマイズを提供しますが、それらの使用の是非や使用方法に関する最終的な判断は利用者によるものとし、当社はプロンプトの提供およびカスタマイズに関して生じたいかなる損害についても一切の責任を負わないものとします。
      </li>
    </ol>

    <h2 style={h2Styles}>第13条（損害賠償）</h2>
    <p style={pStyles}>
      利用者は、本規約に違反することにより、又はサービスの利用に関連して当社に損害を与えた場合、当社に対しその損害を賠償するものとします。また、利用者が、本サービスに関連して他の利用者を含む第三者からクレームを受け又はそれらの者との間で紛争を生じた場合には、直ちにその内容を当社に通知するとともに、利用者の費用と責任において当該クレーム又は紛争を処理し、当社からの要請に基づき、その経過及び結果を当社に報告するものとします。
    </p>

    <h2 style={h2Styles}>第14条（秘密情報）</h2>
    <p style={pStyles}>
      利用者は、本規約又は本サービスに関連して、当社より書面、口頭又は記録媒体等により提供若しくは開示されたか、又は知り得た、当社の技術、営業、業務、組織その他の事項に関する情報（以下「秘密情報」といいます。）を当社の同意なく第三者に開示又は漏洩してはなりません。ただし、以下に定める情報は、秘密情報には当たらないものとします。
    </p>
    <ol style={olStyles}>
      <li style={liStyles}>開示時に、既に利用者が保有していた情報</li>
      <li style={liStyles}>
        開示時に、公知であった情報及び開示後に利用者の責によらず公知となった情報
      </li>
      <li style={liStyles}>
        利用者が第三者から機密保持義務を負うことなく正当に入手した情報
      </li>
      <li style={liStyles}>利用者が秘密情報によることなく独自に開発したもの</li>
    </ol>

    <h2 style={h2Styles}>第15条（情報配信及び配信解除）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        当社は利用者に対して、本サービス関連の情報、製品情報、運営上の事務連絡を含む電子メール、SMS等を配信できるものとし、利用者はこれに予め同意するものとします。
      </li>
      <li style={liStyles}>
        利用者が情報の配信提供を希望しない場合、当社所定の方法で連絡することにより、当社は、本サービスの提供に必要な場合を除いて、前項の情報配信を行わないものとします。
      </li>
    </ol>

    <h2 style={h2Styles}>第16条（有効期間）</h2>
    <p style={pStyles}>
      本規約は、利用者について第2条に基づく登録が完了した日に効力を生じ、第6条に基づき利用者が退会した日又は本サービスの提供が終了した日のいずれか早い日まで、当社と利用者との間で有効に存続するものとします。
    </p>

    <h2 style={h2Styles}>第17条（準拠法・合意管轄）</h2>
    <ol style={olStyles}>
      <li style={liStyles}>
        本規約は、日本法に準拠して解釈されるものとします。
      </li>
      <li style={liStyles}>
        本規約から生じる又は関連するすべての訴訟又は訴訟手続については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
      </li>
    </ol>

    <h2 style={h2Styles}>第18条（協議解決）</h2>
    <p style={pStyles}>
      当社及び利用者は、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。
    </p>

    <p style={pStyles}>以上</p>
  </>
);
